import React, {
  useRef,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { toast } from 'react-toastify';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, DateTime, Select, Autocomplete } from '~/components/Form';
import { CUSTOMIZACAO_RAIZEN } from '~/constants/modules';
import { t, can, number } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import { validation, validationErrors } from '~/helpers/yupValidations';
import api from '~/services/api';

import { Tanks } from '../Tanks';
import * as S from './styles';

export function VirtualTanks({
  close,
  sending,
  visible,
  toggleLoading,
  params,
}) {
  const [initials, setInitials] = useState({});
  const [invoiceVolume, setInvoiceVolume] = useState(0);

  const [tanques, setTanques] = useState([]);

  const formRef = useRef(null);

  const receivedVolume = React.useMemo(
    () =>
      tanques
        ? tanques.reduce(
            (prev, tanque) =>
              prev +
              (tanque.volumefinaldescarganftanque -
                tanque.volumeinicialdescarganftanque),
            0
          )
        : 0,
    [tanques]
  );

  const supplyVolume = React.useMemo(
    () =>
      tanques
        ? tanques.reduce(
            (prev, tanque) => prev + tanque.volumesaidadescarganftanque,
            0
          )
        : 0,
    [tanques]
  );
  // const receivedVolume = React.useMemo(
  //   () =>
  //     initials.tanques
  //       ? initials.tanques.reduce(
  //           (prev, tanque) =>
  //             prev +
  //             (tanque.volumefinaldescarganftanque -
  //               tanque.volumeinicialdescarganftanque),
  //           0
  //         )
  //       : 0,
  //   [initials]
  // );

  // const supplyVolume = React.useMemo(
  //   () =>
  //     initials.tanques
  //       ? initials.tanques.reduce(
  //           (prev, tanque) => prev + tanque.volumesaidadescarganftanque,
  //           0
  //         )
  //       : 0,
  //   [initials]
  // );

  const optionsType = useMemo(
    () => [
      { value: '1', label: 'Não DCM' },
      { value: '2', label: 'DCM' },
    ],
    []
  );

  const isFetchReceiptData = useCallback(async () => {
    try {
      toggleLoading(true);

      const { iddescarganf, idposto } = params;

      await api
        .get(`descargasnfs/${iddescarganf}/${idposto}`)
        .then(({ data }) => {
          setInitials({ ...data, posto: `${data.idposto}` });

          setTanques(data.tanques);
        });
    } catch (err) {
      getToastErrors(err);
    } finally {
      toggleLoading(false);
    }
  }, []);

  const handleSubmit = useCallback(
    async (data) => {
      try {
        toggleLoading(true);

        const schema = Yup.object().shape({
          numeropedidodescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          nfdescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          cnpjdistribuidoradescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          datahoradescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          cnpjtransportadoradescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          volumenfdescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          placactdescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          precounitariodescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          motoristadescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          precototaldescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          datahorainiciodescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          datahorafimdescarganf: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
        });

        await validation(schema, data);

        const formData = Object.assign(initials, {
          ...data,
          datahoradescarganf: `${data.datahoradescarganf} 00:00:00`,
        });

        delete formData._;
        delete formData.posto;

        await api.put('descargasnfs', formData);

        toast.success(t('s.geral.sucessoalteracao'));
        close();
      } catch (err) {
        validationErrors(err, formRef);
      } finally {
        toggleLoading(false);
      }
    },
    [initials]
  );

  const isChangeTank = useCallback(
    ({ key, value }) => {
      const data = { ...initials };
      data.tanques[key] = value;
      setTanques(Object.assign([], data.tanques));
      setInitials(data);
    },
    [initials]
  );

  useEffect(() => {
    if (sending) {
      formRef.current.submitForm();
    }
  }, [sending]);

  useEffect(() => {
    if (visible) {
      isFetchReceiptData();
    }
  }, [visible]);

  if (!visible || typeof initials.idusuario === 'undefined') return <div />;

  return (
    <S.Wrapper ref={formRef} initialData={initials} onSubmit={handleSubmit}>
      <S.InputsGroup>
        <legend>{t('s.relatorio.geral.notafiscal')}</legend>

        <Input
          name="numeropedidodescarganf"
          label={t('s.relatorio.descarga.pedido')}
          type="number"
        />

        <Autocomplete
          disabled
          name="idproduto"
          label="nomeproduto"
          url="produtos"
          unique="idproduto"
          title={t('s.geral.opcoes.combustivel')}
        />

        <Input
          name="nfdescarganf"
          label={t('s.relatorio.geral.notafiscal')}
          type="number"
        />

        <Input
          name="cnpjdistribuidoradescarganf"
          label={t('s.operacao.recebimentonf.cnpjdistribuidoradescarganf')}
          type="number"
        />

        <DateTime
          name="datahoradescarganf"
          label={t('s.operacao.recebimentonf.dataemissaonfdescarganf')}
        />

        <Input
          name="cnpjtransportadoradescarganf"
          label={t('s.operacao.recebimentonf.cnpjtransportadoradescarganf')}
          type="number"
        />

        <Input
          name="volumenfdescarganf"
          label={t('s.operacao.recebimento.volumenfdescarga')}
          type="number"
          getValue={(value) => setInvoiceVolume(parseFloat(value))}
        />

        <Input name="placactdescarganf" label={t('s.menu.cadastro.placact')} />

        <Input
          name="precounitariodescarganf"
          label={t('s.operacao.abastecimento.precounitariomovimentacao')}
          type="number"
        />

        <Input
          name="motoristadescarganf"
          label={t('s.operacao.recebimentonf.motoristadescarganf')}
        />

        <Input
          name="precototaldescarganf"
          label={t('s.operacao.recebimentonf.precototaldescarganf')}
        />

        {can(CUSTOMIZACAO_RAIZEN) && (
          <Select
            name="tipodescarganf"
            label={t('s.cadastro.veiculo.tipoveiculo')}
            options={optionsType}
          />
        )}

        <DateTime
          time
          name="datahorainiciodescarganf"
          label={t('s.operacao.recebimento.datahorainiciodescarga')}
        />

        <DateTime
          time
          name="datahorafimdescarganf"
          label={t('s.operacao.recebimento.datahorafimdescarga')}
        />
      </S.InputsGroup>

      <fieldset>
        <legend>{t('s.relatorio.geral.unidade')}</legend>

        <Autocomplete
          disabled
          name="idposto"
          label="nomeposto"
          unique="idposto"
          title={t('s.menu.configuracao.posto')}
          url="postos"
        />
      </fieldset>

      <fieldset>
        <legend>{t('s.operacao.recebimentonf.tanques')}</legend>

        <Tanks
          // data={initials.tanques}
          data={tanques}
          station={initials.idposto}
          onChangeRow={isChangeTank}
        />
      </fieldset>

      <S.InputGroupResume>
        <legend>{t('s.relatorio.resumooperacao.resumo')}</legend>

        <Input
          disabled
          name="_"
          label={t('s.operacao.recebimento.volumenfdescarga')}
          value={number(invoiceVolume, 2)}
        />

        <Input
          disabled
          name="_"
          label={t('s.relatorio.descarganf.volumerecebido')}
          value={number(receivedVolume || 0, 2)}
        />

        <Input
          disabled
          name="_"
          label={t('s.operacao.recebimentonf.volAbastecido')}
          value={number(supplyVolume, 2)}
        />

        <Input
          disabled
          name="_"
          label={t('s.relatorio.descarga.diferenca')}
          value={number(
            (receivedVolume || 0) + supplyVolume - invoiceVolume,
            2
          )}
        />

        {/* {
          value={number(
                    tanquesVolumeRec +
                      resumoVolAbs -
                      (initials.volumenfdescarganf || volume),
                    0
                  )}

        } */}
      </S.InputGroupResume>
    </S.Wrapper>
  );
}

VirtualTanks.propTypes = {
  close: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  sending: PropTypes.bool.isRequired,
  toggleLoading: PropTypes.func.isRequired,
  params: PropTypes.objectOf(
    PropTypes.shape({
      iddescarganf: PropTypes.string.isRequired,
      idposto: PropTypes.string.isRequired,
    })
  ),
};

VirtualTanks.defaultProps = {
  params: {},
};
